import { render, staticRenderFns } from "./GroupedQueries.vue?vue&type=template&id=c79d3798&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./GroupedQueries.vue?vue&type=script&lang=js&"
export * from "./GroupedQueries.vue?vue&type=script&lang=js&"
import style0 from "./GroupedQueries.vue?vue&type=style&index=0&id=c79d3798&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79d3798",
  null
  
)

export default component.exports